import { render, staticRenderFns } from "./MakesModule.vue?vue&type=template&id=2e483104"
import script from "./MakesModule.vue?vue&type=script&lang=js"
export * from "./MakesModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MakesModule.vue?vue&type=style&index=0&id=2e483104&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports